import { stringify } from 'querystring'
import { logger } from 'utils/logger'
import API from './api'

export interface FastCut {
  id: number
  createdAt: string
  updatedAt: string
  deletedAt: string
  userId: number
  bgmId: number
  transitionId: number
  voiceId: number
  aiPromptTypeId: number
  aiToneTypeId: number
  mainTitle: number
  products: []
  linkInfo: [
    {
      link: string
      productName: string
    }
  ]
  youtubeLink: string
  driveLink: string
  contentCreatedAt: string
  uploadedAt: string
}

export interface Sample {
  title: string
  url: string
  price: string
  thumbnail: string
}
export interface ticket {
  id: number
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  userId: number
  used: boolean
}

interface Product {
  link: string
  productName: string
}
export interface VideoInfo {
  mainTitle: string
  voiceId: number
  bgmId: number
  transitionId: number
  aiToneTypeId: number
  aiPromptTypeId: number
  products: Product[]
  check: boolean
}

export interface ShortVideoInfo {
  mainTitle: string
  templateTitle: string
  link: string
  urls: string[]
  voiceId: number
  userVoiceId: number
  bgmId: number
  backgroundId: number
  templateId: number
  templateType: string
  aiToneTypeId: number
  aiPromptDurationId: number
  subtitleId: number
  subtitleColorId: number
  tempoId: number
  amount: number
}

export interface TextTypeVideoInfo {
  idea: string
  title: string
  userWritten: number
  sourceTypeId: number
  sourceType: string
  voiceId: number
  userVoiceId: number
  languageId: number
  amount: number
  withShort: number
  subtitleId: number
  subtitleColorId: number
  urls: string[]
}

export interface VoiceGroupFactor {
  id: number
  name: string
  service: string
  planName: string
  usable: number
  path: string
  originPrice: number
  price: number
  shortPath: string
  age?: string
  gender?: string
  cashRate: number
  image?: string
  default: number
  sort: number
  status?: string
  samplePath?: string
}

export interface Factor {
  id: number
  name: string
  service: string
  type: string
  usable: boolean
  path: string
}

export interface TransitionFactor {
  id: number
  usable: number
  name: string
  path: string
  imagePath: string
  planName: string
  default: number
  sort: number
}

export interface OutroFactor extends TransitionFactor {}
export interface IntroFactor extends OutroFactor {}

export interface VoiceTagType {
  genders: string[]
  ages: string[]
}
export interface BgmFactor {
  id: number
  name: string
  path: string
  originPrice: string
  price: string
  planName: string
  cashRate: number
  default: number
}

export interface SubtitleColorType {
  id: number
  name: string
  imagePath: string
  default: number
}

export interface StickerLocationType {
  name: string
  value: string
  path: string
}

export interface StickerType {
  id: number
  usable: number
  planName: string
  type: string
  name: string
  path: string
  imagePath: string
  default: number
  sort: number
}
export interface PopContentType {
  id: number
  title: string
  description: string
  imagePath: string
  url: string
  status: boolean
}
export interface Factors {
  factors: Factor[]
}

export interface PromptDuration {
  id: number
  name: string
  originPrice: string
  price: string
  cashRate: number
}

export interface PromptGroup {
  id: number
  usable: number
  planName: string
  name: string
  description: string
  originPrice: number
  price: string
  sort: number
  introduction: string
  default: number
  toneGroup: ToneType[]
}

export interface promptType {
  id: number
  name: string
  description: string
  price: number
  planName: string
}

export interface ToneType {
  id: number
  name: string
  description: string
  originPrice: string
  price: number
  planName: string
  usable: boolean
  default: number
}

export interface SubtitleType {
  id: number
  name: string
  originPrice: string
  price: number
  cashRate: number
  planName: string
  usable: number
  default: number
}

export interface ThumbnailType {
  id: number
  name: string
  planName: string
  path: string
  usable: boolean
  titleLines?: number
}

export interface BackgroundType {
  id: number
  name: string
  path: string
  originPrice: string
  price: string
  cashRate: number
  default: number
}
export interface ShortUrlData {
  title: string
  images: string[]
  titlesSplit: string[]
}

export interface TemplateItem {
  id: number
  type: string
  name: string
  path: string
  videoPath: string
  originPrice: string
  price: string
  cashRate: number
  default: number
}
export interface ShortVideoTemplateType {
  image?: {
    list: TemplateItem[]
    cash: string
    originCash: number
  }
  mix?: {
    list: TemplateItem[]
    cash: string
    originCash: number
  }
  clip?: {
    list: TemplateItem[]
    cash: string
    originCash: number
  }
  etc?: {
    list: TemplateItem[]
    cash: string
    originCash: number
  }
  placid: {
    list: TemplateItem[]
    cash: string
    originCash: number
  }
}
export interface AnimationType extends BackgroundType {}
export interface UsageRequestFactor {
  fastCutId: number
  mainTitle: string
  createdAt: string
  contentCreatedAt: string
  requestedAt: string
  startedAt: string
  uploadedAt: string
  driveLink: string
  status: string
  type?: string
}
export interface UsageRequest {
  totalCount: number
  data: UsageRequestFactor[]
}

export interface TempoType {
  id: number
  name: string
  path: string
  originPrice: number
  price: string
  cashRate: number
  default: number
}

export interface ProductDto {
  link: string
  productName: string
  extensionCollectId: number
  userScript: string
  selectedVideos: string[]
  selectedThumbnails: string[]
  selectedDetails: string[]
  withShort: number
  subtitleFlag: number
  bgmFlag: number
  purchaseInfoFlag: number
  productTemplateId: number

  productTitle: string
}
export interface FastCutProductShortType {
  product: ProductDto
  aiPromptTypeId: number
  aiToneTypeId: number
  voiceId: number
  userVoiceId: number
  bgmId: number
  subtitleId: number
  subtitleColorId: number
  subtitleFontId: number
  subtitleSizeId: number
  includePrice: boolean
}

export interface FastCutProductShortPrevInfoType {
  aiToneTypeId: number
  aiPromptTypeId: number
  voiceId: number
  userVoiceId: number
  bgmId: number
  subtitleId: number
  subtitleColorId: number
  subtitleFontId: number
  subtitleSizeId: number
  includePrice: boolean
}

export async function getList() {
  try {
    const data: FastCut[] | [] = await API.get('/fast-cut', {})
    return data
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getUsageRequest(
  page: number,
  pageSize: number
): Promise<UsageRequest> {
  try {
    const data: UsageRequest = await API.get(
      `/fast-cut/usage-request?page=${page}&pageSize=${pageSize}`,
      {}
    )
    return data
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getShortUsageRequest(
  page: number,
  pageSize: number,
  type: string
): Promise<UsageRequest> {
  try {
    const data: UsageRequest = await API.get(
      `/fast-cut-short/usage-request/${type}?page=${page}&pageSize=${pageSize}`,
      {}
    )
    return data
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getTextShortsUsageRequest(
  page: number,
  pageSize: number
): Promise<UsageRequest> {
  try {
    const data: UsageRequest = await API.get(
      `/fast-cut-text-short/usage-request?page=${page}&pageSize=${pageSize}`,
      {}
    )
    return data
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getProducts() {
  try {
    const data: Sample[] = await API.get('/fast-cut/samples', {})
    return data
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function postList(formData: FormData) {
  try {
    if (formData.get('check')) {
      const result = await API.post('/fast-cut/form', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return result
    } else {
      throw Error('요청 불가')
    }
  } catch (error) {
    console.log(error, 'list')
    // 오류 처리
    throw error
  }
}

export async function createFastCutProductShort(data: FastCutProductShortType) {
  try {
    return await API.post('/fast-cut/product-shorts', data)
  } catch (error) {
    logger.error(JSON.stringify(error))
    throw error
  }
}

export async function _postList(data: VideoInfo) {
  try {
    if (data.check) {
      const result = await API.post('/fast-cut', data)
      return result
    } else {
      throw Error('요청 불가')
    }
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function createShortVideo(formData: FormData) {
  try {
    const result = await API.post('/fast-cut-short/form', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return result
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function createTextVideo(formData: FormData) {
  try {
    const result = await API.post('/fast-cut-text-short/form', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return result
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function _createShortVideo(data: ShortVideoInfo) {
  try {
    const result = await API.post('/fast-cut-short', data)
    return result
  } catch (error) {
    // 오류 처리
    throw error
  }
}
export async function getTicket() {
  try {
    const data: ticket | undefined = await API.get('/fast-cut/ticket')
    return data
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function createVideo(ticketId: number) {
  try {
    return await API.put(`/fast-cut/ticket/${ticketId}`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getBgm(): Promise<BgmFactor[]> {
  try {
    return await API.get(`/fast-cut/bgm/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}
export async function getVoiceTag(): Promise<VoiceTagType> {
  try {
    return await API.get('/fast-cut/voice-tags')
  } catch (e) {
    throw e
  }
}

export async function getVoice(): Promise<VoiceGroupFactor[]> {
  try {
    return await API.get(`/fast-cut/voice-group`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getTransition(): Promise<TransitionFactor[]> {
  try {
    return await API.get(`/fast-cut/transition`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getOutro(): Promise<OutroFactor[]> {
  try {
    return await API.get(`/fast-cut/outro`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getIntro(): Promise<IntroFactor[]> {
  try {
    return await API.get(`/fast-cut/intro`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getAIPromptTypeGroup(): Promise<PromptGroup[]> {
  try {
    return await API.get(`/fast-cut/ai-prompt-type-group`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getAIPromptType(): Promise<promptType[]> {
  try {
    return await API.get(`/fast-cut/ai-prompt-type`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}
export async function getAIPromptDuration(): Promise<PromptDuration[]> {
  try {
    return await API.get(`/fast-cut/ai-prompt-duration`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getMakeTotal(): Promise<any> {
  try {
    return await API.get(`/fast-cut/make-total`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getAIToneLongType(type: string): Promise<ToneType[]> {
  try {
    return await API.get(`/fast-cut/ai-tone-type/${type}`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getAIToneShortType(type: string): Promise<ToneType[]> {
  try {
    return await API.get(`/fast-cut/ai-tone-type/${type}`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getThumbnailCapture(): Promise<ThumbnailType[]> {
  try {
    return await API.get(`/fast-cut/thumbnail/capture`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getThumbnailPlacid(): Promise<ThumbnailType[]> {
  try {
    return await API.get(`/fast-cut/thumbnail/placid`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getBackgroundList(): Promise<BackgroundType[]> {
  try {
    return await API.get(`/fast-cut/background`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getAnimationList(): Promise<AnimationType[]> {
  try {
    return await API.get(`/fast-cut/animation`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getShortImageList(url: string): Promise<ShortUrlData> {
  try {
    return await API.get(`/crawling/short-url?url=${encodeURIComponent(url)}`)
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getShortVideoTemplate(): Promise<ShortVideoTemplateType> {
  try {
    return await API.get(`/fast-cut/template`)
  } catch (error) {
    // 오류 처리
    throw error
  }
}
export async function getSubTitleLong(): Promise<SubtitleType[]> {
  try {
    return await API.get(`/fast-cut/subtitle/long`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getSubTitleShort(): Promise<SubtitleType[]> {
  try {
    return await API.get(`/fast-cut/subtitle/short`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getPopupContent(): Promise<PopContentType> {
  try {
    return await API.get(`/popup`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getSticker(): Promise<StickerType[]> {
  try {
    return await API.get(`/fast-cut/sticker/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getStickerLocation(): Promise<StickerLocationType[]> {
  try {
    return await API.get(`/fast-cut/sticker-locations/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}
export async function getSubtitleColor(): Promise<SubtitleColorType[]> {
  try {
    return await API.get(`/fast-cut/subtitle-color/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}
export async function getSubtitleFont(): Promise<SubtitleColorType[]> {
  try {
    return await API.get(`/fast-cut/subtitle-font/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}
export async function getSubtitleSize(): Promise<SubtitleColorType[]> {
  try {
    return await API.get(`/fast-cut/subtitle-size/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getTempo(): Promise<TempoType[]> {
  try {
    return await API.get(`/fast-cut/tempo/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export interface ChildrenType {
  id: number
  name: string
  originPrice: number
  price: string
}

export interface SourceType {
  id: number
  name: string
  originPrice: number
  price: string
  children?: ChildrenType[]
}

export interface LanguageType {
  id: number
  code: string
  name: string
  default: number
}

export async function getSourceType(): Promise<SourceType[]> {
  try {
    return await API.get(`/fast-cut/source-type/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getLanguages(): Promise<LanguageType[]> {
  try {
    return await API.get(`/fast-cut/languages/`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getVoiceLanguageGroup(
  id: number
): Promise<VoiceGroupFactor[]> {
  try {
    return await API.get(`/fast-cut/voice-language-group/${id}`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export interface Link {
  id: number
  shop: string
  url: string
  title: string
  thumbnailImage: string
}

export interface LinkInfo {
  data: { links: Link[]; remainingCapacity: number; totalCount: number }
}

export async function getLinks(
  pageSize: number,
  page: number
): Promise<LinkInfo> {
  try {
    return await API.get(
      `/extension/links?pageSize=${pageSize}&page=${page}`,
      {}
    )
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function deleteLink(id: number): Promise<void> {
  try {
    return await API.delete(`/extension/${id}`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export interface LinkDetailVideoType {
  detail_images: string[]
  details: string[]

  discount_rate: string
  original_price: string
  original_title: string
  price: string
  product_id: string
  product_infos: string[]
  review_count: string
  reviews: string[]
  sale_count: string
  shop: string
  star_point: string
  thumbnail_images: string[]
  title: string
  url: string
  videos: string[]
}
export interface LinkDetailType {
  aiRecommendTitle: string
  createdAt: string
  deletedAt: string | null
  fastCutId: string | null
  html: string
  id: number
  shop: string
  title: string
  aiScript: string | null
  updatedAt: string
  url: string
  userId: number
  video: LinkDetailVideoType
  generateScriptRequest?: {
    status: 'done' | 'failed' | 'processing'
    aiScript: string
    aiToneTypeId: number
    aiPromptTypeId: number
  }
}
export async function getLinkDetailById(id: number): Promise<LinkDetailType> {
  try {
    return await API.get(`/extension/link-detail/${id}`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getLinkDetailsById(id: number): Promise<LinkDetailType> {
  try {
    return await API.get(`/extension/link-detail/${id}`, {})
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getAiRecommendClipTitle(data: any): Promise<string[]> {
  const extensionCollectIds = data.map(String)
  try {
    return await API.post(`/extension/ai-recommend-clip-title`, {
      extensionCollectIds,
    })
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export interface AIRecommendProductShortTitleType {
  youtubeTitles: string[]
  youtubeTitlesSplit: string[]
}
export async function getAiRecommendProductShortTitle(
  data: any
): Promise<AIRecommendProductShortTitleType> {
  const extensionCollectIds = data.map(String)
  try {
    return await API.post(`/extension/ai-recommend-product-short-title`, {
      extensionCollectIds,
    })
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function generateScriptById(data: {
  extensionCollectId: number
  aiToneTypeId: number
  aiPromptTypeId: number
}): Promise<string> {
  try {
    return await API.post(`/extension/ai-generate-script`, data)
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getScriptByExtensionCollectId(
  extensionCollectId: number | null
): Promise<{
  status: 'done' | 'failed' | 'processing'
  aiScript: string | null
  aiToneTypeId: number
  aiPromptTypeId: number
}> {
  try {
    return await API.get(`/extension/ai-generate-script/${extensionCollectId}`)
  } catch (error) {
    throw error
  }
}

export interface AiThumbnailTitle {
  thumbnailTitles: string[]
  thumbnailTitlesSplit: string[]
  thumbnailSubtitles: string[]
}
export async function getAiRecommendThumbnailTitle(
  data: any
): Promise<AiThumbnailTitle> {
  const extensionCollectIds = data.map(String)
  try {
    return await API.post(`/extension/ai-recommend-thumbnail-title`, {
      extensionCollectIds,
    })
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function createThumbnail(data: any): Promise<any> {
  try {
    return await API.post(`/fast-cut/thumbnail`, data)
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function getThumbnail(id: number): Promise<any> {
  try {
    return await API.get(`/fast-cut/thumbnail/${id}`, {
      responseType: 'arraybuffer',
    })
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function voiceCloning(formData: FormData) {
  try {
    return await API.post('/user-voice/form', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (error) {
    console.log(error, 'voice Cloning')
    // 오류 처리
    throw error
  }
}

export async function getUserVoice(): Promise<VoiceGroupFactor[]> {
  try {
    return await API.get(`/user-voice`)
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export async function purchaseTicket() {
  try {
    const result = await API.post('/user-voice/ticket/purchase', {})
    return result
  } catch (error) {
    // 오류 처리
    throw error
  }
}

export interface ProductTemplate {
  placid: { list: TemplateItem[]; cash: number; originCash: number }
}

export const productTemplate = async (): Promise<ProductTemplate> => {
  try {
    return await API.get('fast-cut/template-product')
  } catch (e) {
    throw e
  }
}
